import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FilesizePipe } from '../pipes/filesize.pipe';
import { NgForFilterPipe } from '../pipes/ngfor-filter.pipe';
import { NgForSortPipe } from '../pipes/ngfor-sort.pipe';
import { NiceDatePipe } from '../pipes/niceDatePipe.pipe';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { TruncatePipe } from '../pipes/truncatePipe.pipe';
import { AddressCommaToLineBreakPipe } from './addressCommaToLineBreak.pipe';
import { BottomSpacerComponent } from './bottom-spacer.component';
import { CatchModule } from './catch.handler';
import { DetailsDemandeCommonComponent } from './details-demande-common/details-demande-common.component';
import { ImageGalleryModal } from './image-gallery-modal/image-gallery.modal';
import { LongPressDirective } from './longpress.directive';
import { MainCouranteDeclarationComponent } from './main-courante-element/elements/item-card-declaration/declaration.component';
import { MainCourantePointeauComponent } from './main-courante-element/elements/item-card-pointeau/pointeau.component';
import { MainCourantePositionComponent } from './main-courante-element/elements/item-card-position/position.component';
import { MainCouranteElementComponent } from './main-courante-element/main-courante-element.component';
import { MainCouranteElementDirective } from './main-courante-element/main-courante-element.directive';
import { SiteSelecteurModalComponent } from './site-selecteur/site-selecteur-modal.component';
import { SiteSelecteurComponent } from './site-selecteur/site-selecteur.component';
import { ThumbnailsGalleryComponent } from './thumbnails-gallery/thumbnails-gallery.component';

@NgModule({
  imports: [CommonModule, IonicModule, FontAwesomeModule, TranslateDirective, TranslatePipe, FormsModule, RouterModule, CatchModule],
  declarations: [
    TruncatePipe,
    NiceDatePipe,
    NgForFilterPipe,
    NgForSortPipe,
    FilesizePipe,
    SafeUrlPipe,
    ImageGalleryModal,
    BottomSpacerComponent,
    SiteSelecteurComponent,
    SiteSelecteurModalComponent,
    MainCouranteElementComponent,
    MainCouranteDeclarationComponent,
    MainCourantePointeauComponent,
    MainCourantePositionComponent,
    MainCouranteElementDirective,
    DetailsDemandeCommonComponent,
    ThumbnailsGalleryComponent,
    AddressCommaToLineBreakPipe,
    LongPressDirective,
  ],
  exports: [
    TruncatePipe,
    NiceDatePipe,
    NgForFilterPipe,
    NgForSortPipe,
    FilesizePipe,
    SafeUrlPipe,
    ImageGalleryModal,
    BottomSpacerComponent,
    SiteSelecteurComponent,
    SiteSelecteurModalComponent,
    MainCouranteElementComponent,
    MainCouranteDeclarationComponent,
    MainCourantePointeauComponent,
    MainCourantePositionComponent,
    MainCouranteElementDirective,
    DetailsDemandeCommonComponent,
    ThumbnailsGalleryComponent,
    AddressCommaToLineBreakPipe,
    LongPressDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
